import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputBaseComponentProps,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useState } from "react";
import { Controller, FieldValues, Path, UseControllerProps } from "react-hook-form";

import { ariaLabel } from "src/constants";

interface Props<T extends FieldValues> {
  error: string | undefined;
  control: UseControllerProps<T>["control"];
  rules?: UseControllerProps<T>["rules"];
  label?: string;
  placeholder?: string;
  controllerName?: string;
  inputProps?: InputBaseComponentProps;
  autoComplete?: string;
  id?: string;
  autoFocus?: boolean;
}

export function PasswordInput<T extends FieldValues>({
  error,
  control,
  rules,
  label = "Votre mot de passe",
  placeholder = "Votre mot de passe",
  controllerName = "password",
  inputProps,
  autoComplete,
  id,
  autoFocus,
}: Props<T>) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl fullWidth variant="outlined" error={error !== undefined}>
      <InputLabel htmlFor={id || controllerName}>{label}</InputLabel>
      <Controller<T>
        name={controllerName as Path<T>}
        control={control}
        rules={rules}
        render={({ field: { ref, ...rest } }) => (
          <OutlinedInput
            label={label}
            type={showPassword ? "text" : "password"}
            placeholder={placeholder}
            inputProps={inputProps}
            autoComplete={autoComplete}
            id={id}
            aria-describedby="password-error-helper-text"
            autoFocus={autoFocus}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? ariaLabel.hidePassword : ariaLabel.showPassword}
                  onClick={() => setShowPassword(true)}
                  onMouseDown={() => setShowPassword(false)}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            inputRef={ref}
            {...rest}
          />
        )}
      />
      <FormHelperText id="password-error-helper-text">{error}</FormHelperText>
    </FormControl>
  );
}
